import Edit from "./Edit";
import List from "./List";
import View from "./View";

export default {
  Edit,
  List,
  View,
};
